// extracted by mini-css-extract-plugin
export default {"map":"VenuesMap_map__flGqs","mapInstructions":"VenuesMap_mapInstructions__eLOSF"};